import * as InvoiceService from '../services/invoice-service';
import * as OTRInvoiceService from '../services/otr/otr-invoice-service';

export function resetState(state) {
  return function (dispatch) {
    dispatch(reset(state));
  };
}

export function search(invoiceStatus, params, isOTR, page, pageSize) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.search(invoiceStatus, params, page, pageSize);
      dispatch(success('SEARCH_INVOICES', response.data));
    } catch(err) {
      dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function findInvoices(status, params, isOTR, page, pageSize) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.list(status, params, page, pageSize);
      dispatch(success('FETCH_INVOICES', response.data));
    } catch(err) {
      dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function generateInvoice(invoiceIdList, date, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.generateInvoice(invoiceIdList, date);
      dispatch(success('GENERATE_INVOICE', response.data));      
    } catch(err) {
      dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function unInvoice(invoiceIdList, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.unInvoice(invoiceIdList);
      dispatch(success('UN_INVOICE', response.data));
    } catch(err) {
      dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function processPayment(payment, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.processInvoicePayment(payment);
      dispatch(success('PROCESS_PAYMENT', response.data));
    } catch(err) {
      dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function save(invoice, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.save(invoice);
      return dispatch(success('ADD_INVOICE', response.data));
    } catch (err) {
      return dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function update(invoice, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
      const response = await invoiceService.update(invoice);
      return dispatch(success('UPDATE_INVOICE', response.data));
    } catch (err) {
      return dispatch(error('INVOICE_ERROR', err));
    }
  };
}

export function getInvoiceById(invoiceId, isOTR) {
  return async function (dispatch) {
    const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
    const response = await invoiceService.getInvoiceById(invoiceId);
    return dispatch(success('LOAD_INVOICE_DETAIL_SUCCESS', response.data));
  };
}

export function saveCheck(invoiceId, checkData, isOTR) {
  return function (dispatch) {
    dispatch(process());
    const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
    return invoiceService.saveCheck(invoiceId, checkData)
      .then(response => dispatch(success('SAVE_INVOICE_CHECK_SUCCESS', response)))
      .catch(err => dispatch(error('SAVE_CHECK_FAILED', err)));
  };
}

function reset(type) {
  return {
    type: type,
  };
}

function process() {
  return {
    type: 'PROCESSING_INVOICE',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}
function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}